// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const REVIEW_SECTION_OFFER = "Nab\u00eddka";
export const SEO_TITLE_STROLLER_COMPONENT_DETAILED_REVIEW = "Podrobn\u00e1 recenze";
export const SEO_TITLE_STROLLER_COMPONENT_FORUM = "Ot\u00e1zky/poradna";
export const SEO_TITLE_STROLLER_COMPONENT_REVIEWS = "Hodnocen\u00ed";
export const SEO_TITLE_STROLLER_COMPONENT_VIDEO = "Video";
export const STROLLER_CARD_COMPARE = "Porovnej";
export const STROLLER_CARD_COMPARE_REMOVE = "Odeber";
export const STROLLER_DETAIL_ADD_TO_PROFILE = "P\u0159idej do v\u00fdbavi\u010dky";
export const STROLLER_DETAIL_REMOVE_FROM_PROFILE = "Sma\u017e z v\u00fdbavi\u010dky";
export const STROLLER_DETAIL_SEAERCH_STROLLER = "Hledej ko\u010d\u00e1rek";
